import styles from "./index.module.scss";
import Breadcrumbs from "../../common/breadcrumbs";

export default function Side({ title, children, side }) {
  return (
    <div className="container">
      <Breadcrumbs />
      {title && <h1>{title}</h1>}
      <div className={styles.Content}>
        <div className={styles.Block}>{children}</div>
        <div className={styles.Side}>{side}</div>
      </div>
    </div>
  );
}
